import api from 'Application/api/api';

const updateInstructionArea = (areaId, data, cancelToken = null) =>
    api.put(`/education/instruction-areas/${areaId}`, data, { cancelToken });

export default updateInstructionArea;
